import type { ReceiptTemplate } from '../schema';

export const bestBuyTemplate: ReceiptTemplate = {
  id: 'best-buy',
  name: 'Best Buy Receipt',
  brand: 'BEST BUY',
  description: 'Electronics retail store receipt template',
  settings: {
    width: 280,
    font: 'Bit Matrix A',
    fontSize: 12,
    paperStyle: 'thermal',
    backgroundColor: '#ffffff',
    textColor: '#1a1a1a',
    showWatermark: false,
    currency: '$',
    currencyPosition: 'before',
    spacing: 'narrow',
  },
  sections: [
    {
      id: 'bb-header',
      type: 'header',
      enabled: true,
      config: {
        alignment: 'center',
        logoUrl: '/logos/best-buy.png',
        logoData: '',
        logoWidth: 140,
        logoHeight: 50,
        businessName: '',
        businessNameFontSize: 20,
        addressLines: [
          'STORE #0127',
          '1200 DARK AVENUE',
          'MONSTERVILLE, CA 94608',
          '(510) 555-0127',
        ],
        showDivider: true,
        dividerStyle: 'solid',
      },
    },
    {
      id: 'bb-trans',
      type: 'custom-message',
      enabled: true,
      config: {
        alignment: 'left',
        message: 'TRANS#: 0127-0104-8472\nDATE: 01/04/2026  TIME: 14:32:18\nREG: 04  CASHIER: JAMES S',
        fontSize: 12,
        showDivider: true,
        dividerStyle: 'dashed',
        isBold: false,
      },
    },
    {
      id: 'bb-items',
      type: 'items-list',
      enabled: true,
      config: {
        alignment: 'left',
        showQuantity: true,
        showPrice: true,
        showTotal: false,
        items: [
          { id: 'bb-item-1', name: 'SAMSUNG 55" 4K TV', quantity: '1', price: '449.99'},
          { id: 'bb-item-2', name: 'HDMI CABLE 6FT', quantity: '2', price: '19.99'},
          { id: 'bb-item-3', name: 'SURGE PROTECTOR', quantity: '1', price: '29.99'},
        ],
        showDivider: true,
        dividerStyle: 'dashed',
      },
    },
    {
      id: 'bb-totals',
      type: 'totals',
      enabled: true,
      config: {
        alignment: 'right',
        labelPosition: 35,
        labelAlignment: 'left',
        lines: [
          { id: 'bb-subtotal', label: 'SUBTOTAL', value: '519.96', isBold: false, isLarge: false },
          { id: 'bb-tax', label: 'TAX', value: '46.15', isBold: false, isLarge: false },
          { id: 'bb-total', label: 'TOTAL', value: '566.11', isBold: true, isLarge: true },
        ],
        increaseTotalSize: true,
        totalSizeIncrease: 20,
        showDivider: true,
        dividerStyle: 'double',
      },
    },
    {
      id: 'bb-payment',
      type: 'payment',
      enabled: true,
      config: {
        alignment: 'left',
        paymentType: 'card',
        cardFields: [
          { id: 'bb-card', label: 'VISA', value: '************4144' },
          { id: 'bb-auth', label: 'AUTH', value: '847291' },
          { id: 'bb-status', label: 'STATUS', value: 'APPROVED' },
        ],
        cashFields: [],
        showDivider: true,
        dividerStyle: 'spaces',
      },
    },
    {
      id: 'bb-rewards',
      type: 'custom-message',
      enabled: true,
      config: {
        alignment: 'center',
        message: 'MY BEST BUY REWARDS\nMember: MIKE WAZOWSKI\nPoints Earned: 566',
        fontSize: 10,
        showDivider: true,
        dividerStyle: 'spaces',
        isBold: false,
      },
    },
    {
      id: 'bb-barcode',
      type: 'barcode',
      enabled: true,
      config: {
        alignment: 'center',
        type: 'code128',
        value: '012701048472',
        showValue: true,
        width: 1.5,
        height: 40,
        showDivider: false,
        dividerStyle: 'solid',
      },
    },
    {
      id: 'bb-return',
      type: 'custom-message',
      enabled: true,
      config: {
        alignment: 'center',
        message: 'Return Policy: 15 days for most items\nwith receipt. Visit BestBuy.com/returns',
        fontSize: 10,
        showDivider: false,
        dividerStyle: 'solid',
        isBold: false,
      },
    },
  ],
};

